declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_mutable_and_read_only_foo extends $mol_object {
		readonly( ): any
		mutable( next?: any ): any
	}
	
}

//# sourceMappingURL=simple_mutable_and_read_only.view.tree.d.ts.map